// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".export-link-wrapper[data-v-91b27ae8]{display:flex;flex-wrap:nowrap;align-items:center}.export-link-wrapper span[data-v-91b27ae8]{text-overflow:ellipsis;overflow-x:hidden;margin-right:10px}", ""]);
// Exports
module.exports = exports;
